import { render } from "./product_list.vue?vue&type=template&id=5f1349e8"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"

import "./product_list.vue?vue&type=style&index=0&id=5f1349e8&lang=css"
script.render = render

export default script